export class UserNotProvisionedError extends Error {
  constructor() {
    super('Your account does not have access to Clear Verify. Contact your organization.');
    this.name = 'UserNotProvisionedError';
  }
}
